import React, {Component} from "react"

import {BasketItemType, Product, Deal} from "@irati/types"
import stocksService from "@irati/stock/services/stocks"
import willReachMaxAmount from "@irati/deals/helpers/product/willReachMaxAmount"
import FormattedMessage, {injectIntl, InjectIntl, getResolvedMessage} from "@irati/utils/lang"
import {H2} from "@irati/ui/src/Typography"
import Form from "@irati/ui/src/Form"
import {Select} from "@irati/ui/src/FormItem"
import {Hr} from "@irati/ui/src/Layout"
import basket from "@irati/checkout/utils/basket"
import withPerkOrReward, {WithPerkOrReward} from "@irati-web/flexi-rewards/src/utils/withPerkOrReward"
import {productsForCinema, getCinemaLocations, CinemaLocation} from "@irati/checkout/utils/redemption/products"

import ProductTypes from "../../../constants/productTypes"
import LimitWrapper from "./shared/LimitWrapper"
import QuantityContainer from "./shared/Quantity/QuantityContainer"
import {QuantityOnChange} from "./shared/Quantity/QuantityItem"

interface Props extends InjectIntl, WithPerkOrReward {
  deal: Deal
  products: Product[]
}

interface State {
  selectedProducts?: Product[]
  selectedLocation?: string | null
  willReachMax: boolean
  cinemaLocations: CinemaLocation[]
}

class CinemaProduct extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      selectedLocation: null,
      willReachMax: false,
      cinemaLocations: []
    }
  }

  componentDidMount() {
    const {deal, products} = this.props
    basket.clear()
    stocksService.stockCount(deal.uuid).then(({stockTotals}) => {
      const cinemaLocations = getCinemaLocations(products)
      cinemaLocations.forEach((item) => {
        item.products.forEach((product) => {
          product.outOfStock = stockTotals[product.uuid] === 0
        })
      })
      this.setState({cinemaLocations})
    })
  }

  handleSelectCinema = (selectedLocation: string) => {
    basket.clear()
    const availableProducts = productsForCinema(this.props.products, selectedLocation, this.state.cinemaLocations)
    this.setState({
      selectedProducts: availableProducts,
      selectedLocation
    })
  }

  handleUpdateQuantity: QuantityOnChange = (type, productId) => {
    const {deal, isRewards} = this.props
    let count = basket.items.find((t) => t.productId === productId)?.count || 0
    if (type === "+") {
      count++
    } else {
      count--
    }
    const entityType = isRewards ? BasketItemType.FlexiReward : BasketItemType.Deal
    basket.setProduct(entityType, deal.uuid, productId, {count})
    this.setState({
      willReachMax: willReachMaxAmount(deal, productId)
    })
  }

  render() {
    const {deal, formatMessage} = this.props
    const {cinemaLocations, selectedLocation, selectedProducts} = this.state

    const options = cinemaLocations.map((loc) => {
      const allOutOfStock = loc.products.filter((p) => !p.outOfStock).length === 0
      return {
        value: loc.location,
        label: loc.location,
        disabled: allOutOfStock
      }
    })

    return (
      <div>
        <H2>
          <FormattedMessage id="perks.components.productForms.cinemaSelection.title" />
        </H2>
        <LimitWrapper deal={deal} productType={ProductTypes.CINEMA}>
          <Form>
            <Select
              value={getResolvedMessage(this, "selectedLocation")}
              isClearable={false}
              placeholder={formatMessage({id: "perks.components.productForms.cinemaSelection.placeholderText"})}
              name="selectedLocation"
              onChange={(value) => this.handleSelectCinema(value)}
              options={options}
            />
          </Form>
          {selectedLocation && (
            <div>
              <Hr />
              <QuantityContainer deal={deal} handleClick={this.handleUpdateQuantity} products={selectedProducts} />
            </div>
          )}
        </LimitWrapper>
      </div>
    )
  }
}

export default withPerkOrReward(injectIntl(CinemaProduct))
